
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { Layout,Avatar, Menu, Breadcrumb,Button,Row, Col, Divider,Card,Dropdown,Switch,
    message, Tooltip,Image,Drawer  } from 'antd';
import {
  LogoutOutlined,
  HomeOutlined,
  MenuOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { MdMailOutline, MdPhone, MdShoppingCart } from "react-icons/md";
import { Badge, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem } from 'reactstrap';

import { NavLink } from 'react-router-dom'
import { PageHeader, Descriptions,Affix,notification,Modal,Alert } from 'antd';
import { Link,withRouter} from 'react-router-dom';
import axios from 'axios'
import logo from '../assets/umojalogo.png';
import * as serverconfig from "./serverconn";
import { primarycolor } from "./primarycolor";
import ReconnectingWebSocket from "reconnecting-websocket";
import * as serversocketconfig from "./serversocketconfig";
import tickAudio from "../assets/sounds/that-was-quick.mp3";
import UIfx from "uifx";


const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
const style = { background: '#0092ff', padding: '8px 0' };
const { Meta } = Card;


const LoginLayout = (props) => {

  const [user_profile, setuser_profile] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [notifications, setnotifications] = useState([]);
  const [numberofnotifications, setnumberofnotifications] = useState(0);

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [login_visible, setlogin_visible] = useState(false);
  const [shownotificationmodal, setshownotificationmodal] = useState(false);
 

  // Function to check if the screen size is mobile
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
  };

  useEffect(() => {
    // Check initial screen size
    checkIsMobile();

    //get date
    load_initdata()

    // Add event listener for screen resize
    window.addEventListener('resize', checkIsMobile);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);


  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onClose = () => {
    setDrawerVisible(false);
  };


    const load_initdata=()=>{

    }

    return (
    
          <Layout className="site-layout" style={{background:'#fff',margin:10,padding:0}} >

           <div style={{margin:10}} >
         
              {
                isMobile===true ? 
                <div style={{display:'flex'}}>
                  <span>
                  <MenuOutlined onClick={showDrawer} style={{ position:'absolute', top: '20px', left: '20px', zIndex: 1000, fontSize: '24px', cursor: 'pointer' }} />
                    <Drawer
                      title="Tabs"
                      placement="left"
                      onClose={onClose}
                      visible={drawerVisible}
                      width={200}         
                    >
                      <Menu mode="inline" >
                      <Menu.Item key="1" onClick={()=>{onClose()}}> <NavLink to='/'><span> <HomeOutlined/ > Home</span></NavLink></Menu.Item>
                      <Menu.Item key="3" onClick={()=>{onClose()}}><NavLink to='/movement/'><span> <SwapOutlined/> Package Movement</span></NavLink></Menu.Item>

                  </Menu>
                    </Drawer>
                  </span>
                

                </div>
             : 

              <div style={{
                display:'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}>
                      <Image
                        width={50}
                        height={50}
                        src={logo}   
                        preview={false} 
                        />

                    <div style={{
                      marginLeft: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '24px'
                    }}>
                      <NavLink to='/' onClick={()=>{onClose()}} style={{color: primarycolor, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <HomeOutlined /> Home
                      </NavLink>
                      <NavLink to='/movement/' onClick={()=>{onClose()}} style={{color: primarycolor, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <SwapOutlined /> Package Movement
                      </NavLink>
                    </div>

                </div>

              }

           </div>

            <Content style={{ margin: '0 3px',background:'#fff' }}>
            <div className="site-layout-background" >
             {props.children}
           </div>
           </Content>
           <Footer style={{ textAlign: 'center',fontWeight:'bolder' }}>Copyright © 2025 umoja integrated couriers</Footer>
       </Layout>
  );

}

export default withRouter(LoginLayout);

  
